<div
  *ngIf="
    scheduleName &&
    this.originalFormData &&
    this.originalFormData[scheduleName] &&
    this.originalFormData[scheduleName].length &&
    isModalOpened
  "
  cdkDrag
  class="rfq-drag quote-schedule"
  (mousedown)="updateZIndex()"
  (cdkDragStarted)="dragStart()"
  (cdkDragEnded)="dragEnd()"
>
  <div class="drag-preview" *cdkDragPreview matchSize></div>
  <div class="rfq-container-content" id="content">
    <div class="rfq-container-content__menu-bar" cdkDragHandle>
      RFQ {{ parentTabIndex + 1 }}, Leg {{ parentLegIndex + 1 }}:
      Schedule&mdash;excluding sales margin
      <button
        class="rfq-container-content__menu-bar--right-button-close"
        (click)="modalChanged()"
      ></button>
    </div>

    <div class="rfq-container-content__main scrollable-content">
      <form [formGroup]="$any(scheduleArray)" autocomplete="off">
        <div class="body">
          <table ui-table id="table-data">
            <thead>
              <tr>
                <th *ngFor="let column of columns">
                  {{ column.longName }}
                </th>

                <th *ngFor="let column of quoteSpecificColumns">
                  {{ column }}
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container>
                <tr *ngFor="let item of scheduleArrayControls; index as i">
                  <ng-container [formGroupName]="i">
                    <td
                      *ngFor="let column of columns; index as columnIndex"
                      class="data-cell"
                      #tableResults
                    >
                      @if (column.shortName === 'fixingNumber') {
                        {{ item.controls[column.shortName].value }}
                      } @else {
                        {{ item.controls[column.shortName].value }}
                      }
                    </td>
                    <td *ngFor="let j of [0, 1, 2, 3]" class="data-cell">
                      @if (!details) {
                        -
                      } @else {
                        @if (j === 0 && details && details[i]) {
                          <app-movement-indicator
                            [value]="details[i]?.premiumAmountBid"
                            [isPremium]="true"
                          >
                          </app-movement-indicator>
                        } @else if (j === 1 && details && details[i]) {
                          <app-movement-indicator
                            [value]="details[i]?.premiumAmountAsk"
                            [isPremium]="true"
                          >
                          </app-movement-indicator>
                        } @else if (j === 2 && details && details[i]) {
                          <app-movement-indicator
                            [value]="details[i]?.volBid"
                            [isPremium]="false"
                          >
                          </app-movement-indicator>
                        } @else if (j === 3 && details && details[i]) {
                          <app-movement-indicator
                            [value]="details[i]?.volAsk"
                            [isPremium]="false"
                          >
                          </app-movement-indicator>
                        }
                      }
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

        <div class="panel">
          <button
            class="ui-button primary"
            (click)="onCopyToClipboardClicked()"
            type="button"
          >
            Copy to clipboard
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
